import { __remove, __set } from "../store/axios_indicator";
import System from "src/helper/system";
const { storageName: { PRODUCT_COMPARE_API, } } = System

class ProductCompareAPICall {

    getAll = async () => {
        __set('PRODUCT_COMPARE_API_CALL');
        let data = {};
        let res = {};
        if (localStorage.getItem(PRODUCT_COMPARE_API)) {
            data = JSON.parse(localStorage.getItem(PRODUCT_COMPARE_API));
        }
        res.data = data;
        __remove('PRODUCT_COMPARE_API_CALL');
        return res;
    };

    setAll = async (data) => {
        __set('PRODUCT_COMPARE_API_CALL');
        let res = {};
        localStorage.setItem(PRODUCT_COMPARE_API, JSON.stringify(data));
        __remove('PRODUCT_COMPARE_API_CALL');
        return res;
    };
    
    removeAll = async () => {
        __set('PRODUCT_COMPARE_API_CALL');
        let res = {};
        localStorage.removeItem(PRODUCT_COMPARE_API);
        __remove('PRODUCT_COMPARE_API_CALL');
        return res;
    };
}

export default ProductCompareAPICall;